import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';
import Rebase from 're-base';

// Initialize Firebase
const config = {
  apiKey: "AIzaSyDCPnEiK3ZT5CxD52hp6CziYj6xGI_I3iU",
  authDomain: "chaterang-3f4bd.firebaseapp.com",
  databaseURL: "https://chaterang-3f4bd.firebaseio.com",
  projectId: "chaterang-3f4bd",
  storageBucket: "chaterang-3f4bd.appspot.com",
  messagingSenderId: "29132313741"
};

const app = firebase.initializeApp(config);

// configure authentication 
export const auth = firebase.auth();
export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const githubProvider = new firebase.auth.GithubAuthProvider();

//configure database
const db = firebase.database(app);
const base = Rebase.createClass(db);

export default base;



// WEBPACK FOOTER //
// ./src/base.js